import {
  RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ,
  SET_CREATE_TRANSACTION_RESPONSE_OBJ,
} from "../action";
import { createTransactionResponseObj } from "./initial-store";

const initialState = createTransactionResponseObj;

function createTransactionResponseObjReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_CREATE_TRANSACTION_RESPONSE_OBJ:
      newState = action.payload.responseData;
      return newState;

    case RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ:
      newState = initialState;
      return newState;

    default:
      return state;
  }
}

export default createTransactionResponseObjReducer;
